export enum BoxRotation {
  ZERO = 0,
  ONE = 90,
  TWO = 180,
  THREE = 270,
}
